export default "__VITE_ASSET__S_SMgfwp__"